// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3EqjF","label":"Labeled_label__2c_-1","divider":"Labeled_divider__3EDlA"};